import React from 'react';
import Menu from './Menu';
import './App.css';

function App() {
  return <Menu />;
}

export default App;
